<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'monitoringsCrud'"
            :crudName="$t('Monitoring')"
            :newText="$t('Add') + '  ' + $t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
            :customFilters="customFilters"
            :extra="extra"
            @filtered_ds="filtered_ds"
            @view-map="viewMap"
        >
        </base-crud>

        <b-modal
            v-model="showMapModal"
            :title="$t('Event Position')"
            size="lg"
            ok-only
            :ok-title="$t('Close')"
            ok-variant="secondary"
        >
          <GmapMap
              v-if="mapPosition"
              :zoom="17"
              :center="mapPosition"
              style="width: 100%; height: 450px"
          >
            <GmapMarker :position="mapPosition" :icon="markerIcon" @click="showEventDetails = true" />
          </GmapMap>
          <p v-else class="text-muted mb-0">{{ $t('No position recorded for this event') }}</p>
        </b-modal>

        <b-modal
            v-model="showEventDetails"
            :title="$t('Event Details')"
            ok-only
            :ok-title="$t('Close')"
            ok-variant="secondary"
            size="md"
        >
          <div v-if="selectedRow" class="event-details">
            <div class="ed-row">
              <span class="ed-label"><i class="fas fa-tag"></i> {{ $t('Event Type') }}</span>
              <span class="badge" :class="eventTypeBadgeClass(selectedRow.event_type)">
                {{ eventTypeLabel(selectedRow.event_type) }}
              </span>
            </div>
            <div class="ed-row">
              <span class="ed-label"><i class="fas fa-car"></i> {{ $t('Vehicle') }}</span>
              <strong>{{ selectedRow.vehicle ? selectedRow.vehicle.name : '-' }}</strong>
            </div>
            <div class="ed-row" v-if="selectedRow.area">
              <span class="ed-label"><i class="fas fa-map-marked-alt"></i> {{ $t('Area') }}</span>
              <strong>{{ selectedRow.area.name }}</strong>
            </div>
            <div class="ed-row">
              <span class="ed-label"><i class="fas fa-clock"></i> {{ $t('Created At') }}</span>
              <strong>{{ selectedRow.created_at_f }}</strong>
            </div>
            <div class="ed-row" v-if="mapPosition">
              <span class="ed-label"><i class="fas fa-map-marker-alt"></i> {{ $t('Position') }}</span>
              <strong>{{ mapPosition.lat.toFixed(6) }}, {{ mapPosition.lng.toFixed(6) }}</strong>
            </div>
            <div class="ed-description">
              <span class="ed-label"><i class="fas fa-align-left"></i> {{ $t('Event Description') }}</span>
              <p class="mb-0">{{ translateDescription(selectedRow.event_description) }}</p>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "created_at_f",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      created_at: "",
      table: "monitoringsTable",
      showMessageImport: false,
      monitoringsCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "area_id",
        "vehicle_id",
        "event_type",
        "event_description",
        "created_at_f",
        "actions"
      ],
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud view",
          title: "Ver Mapa",
          name: "view-map",
          icon: "fas fa-map-marker-alt",
        },
      ],
      showMapModal: false,
      showEventDetails: false,
      mapPosition: null,
      selectedRow: null,
      markerIcon: {
        url: require("@/assets/images/pin/map-pin-generic.svg"),
        scaledSize: { width: 40, height: 60 },
        anchor: { x: 20, y: 60 },
      },
      tableData: [
        "id",
        "area_id",
        "vehicle_id",
        "event_type",
        "event_description",
        "created_at"
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "area_id",
          "vehicle_id",
          "event_type"
        ],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          area_id: this.$t("Area"),
          vehicle_id: this.$t("Vehicle"),
          event_type: this.$t("Event Type"),
          event_description: this.$t("Event Description"),
          created_at_f: this.$t("Created At"),
          actions: this.$t("action"),
        },
        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          event_type: [
            { id: 'entry', text: 'Entrada' },
            { id: 'exit', text: 'Saída' },
            { id: 'device_detached', text: 'Dispositivo desprendido' },
            { id: 'device_reattached', text: 'Dispositivo reencaixado' }
          ]
        },
        templates: {
          vehicle_id: function (h, row, index) {
            return row.vehicle ? row.vehicle.name : "";
          },
          area_id: function (h, row, index) {
            return row.area ? row.area.name : "";
          },
          event_type: (h, row) => {
            const text = this.eventTypeLabel(row.event_type);
            const badgeClass = this.eventTypeBadgeClass(row.event_type);

            if (badgeClass === 'badge-secondary') {
              return text;
            }

            return h('span', { class: ['badge', badgeClass] }, text);
          },
          event_description: (h, row) => this.translateDescription(row.event_description),
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
              this.$parent.$parent.$parent.created_at != null &&
              this.$parent.$parent.$parent.created_at != ""
          ) {
            requestData.params.created_at =
                this.$parent.$parent.$parent.created_at;
          }
          requestData.params.query = "";
          requestData.params.with = ["vehicle", "area"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "monitorings",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered_ds(date) {
      this.created_at = date;
    },
    query: function (query) {
      const columns = {
        id: "id",
        vehicle_id: "vehicle[name]",
        area_id: "area[name]",
        event_type: "event_type",
        event_description: "event_description",
        created_at: "created_at"
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (!value) return;
        filters += columns[index] + "=" + encodeURIComponent(value) + "&";
      });

      return filters;
    },
    openInput() {
    },
    viewMap({ row }) {
      this.selectedRow = row;
      this.mapPosition = this.resolvePosition(row);
      this.showMapModal = true;
    },
    eventTypeLabel(eventType) {
      const translations = {
        entry: this.$t('Entry'),
        exit: this.$t('Exit'),
        device_detached: this.$t('Device Detached'),
        device_reattached: this.$t('Device Reattached'),
      };
      return translations[eventType] || eventType;
    },
    eventTypeBadgeClass(eventType) {
      const badgeClasses = {
        device_detached: 'badge-danger',
        device_reattached: 'badge-success',
      };
      return badgeClasses[eventType] || 'badge-secondary';
    },
    translateDescription(description) {
      if (!description) return '';

      let translated = description;

      const translations = {
        'Initial log: Vehicle entry area': this.$t('Initial log: Vehicle entry area'),
        'Initial log: Vehicle exit area': this.$t('Initial log: Vehicle exit area'),
        'State changed: Vehicle entry area': this.$t('State changed: Vehicle entry area'),
        'State changed: Vehicle exit area': this.$t('State changed: Vehicle exit area'),
        ' at position ': ' ' + this.$t('at position') + ' ',
      };

      for (const [key, value] of Object.entries(translations)) {
        if (translated.includes(key)) {
          translated = translated.replace(key, value);
        }
      }

      return translated;
    },
    resolvePosition(row) {
      if (row.lat != null && row.long != null) {
        return { lat: parseFloat(row.lat), lng: parseFloat(row.long) };
      }

      // eventos antigos de entrada/saída de área não têm lat/long em coluna própria,
      // só embutido no texto: "at position (lat, long)"
      const match = row.event_description
          ? row.event_description.match(/\(([-\d.]+),\s*([-\d.]+)\)/)
          : null;

      if (!match) return null;

      return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.event-details {
  font-size: 14px;
}

.ed-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #f0f0f0;
}

.ed-row:last-of-type {
  border-bottom: none;
}

.ed-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6c757d;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}

.ed-label .fas {
  width: 16px;
  text-align: center;
  color: #8a8f98;
}

.ed-description {
  padding-top: 12px;
  margin-top: 4px;
  border-top: 1px solid #f0f0f0;
}

.ed-description p {
  color: #333;
  line-height: 1.5;
  margin-top: 6px;
}
</style>
